// import React from "react";
import { Container, Col, Row } from "react-bootstrap";
import React, { useEffect, useState, useMemo, useContext, useRef } from "react";
import EquityImg from "../../../Images/product-equity.png";
import "./ExploreEquities.css";
// import Autocomplete from 'react-autocomplete'
import URLstateContext from "../../../provider/CommonContext";
// import "../ExploreEquities/Custom.css"
import "../ExploreEquities/Custom.css"
import { useNavigate } from "react-router-dom";
import { useLocalStorage } from "../../utils/useLocalStorage";
import { setcompcode, userSelector, clearState } from '../../features/User/UserSlice';
import LoginPopup from "../../CommonUI/LoginPopup/LoginPopup";
import { useSelector, useDispatch } from 'react-redux';
// import Autocomplete from "../../AllEquities/Autocomplete/Autocomplete";


function ExploreEquities() {
    const { BaseURL, setcompserachcocode } = useContext(URLstateContext);
    const [companysearch, setcompanysearch] = useState([]);
    const [setTextval, setText] = useState([]);
    const [suggestions, setSuggestions] = useState([]);
    const [showResults, setShowResults] = useState(false);
    //const [cocode, setcocode] = useLocalStorage("cocode", "");
    const [show, setShow] = useState(false);
    const childRef = useRef(null);
    const dispatch = useDispatch();
    const usrname = useSelector(state => state.user.email);
    // console.log(usrname)
    const { isSuccess, isError, errorMessage } = useSelector(
        userSelector
    );
    let tabName = "Stocks";


    useEffect(() => {
        if (isSuccess) {
            setShow(false);

        }
        if (isError) {
            dispatch(clearState());
        }
    }, [isSuccess, isError]);

    const clickToggleLoginPopup = (showhide, path) => {
        if (isSuccess) {
            navigate(path);
        }
        else {
            childRef.current.changeTogglePopup(showhide);
        }
    }

    let navigate = useNavigate();
    let DataFilter = [];
    let getval = [];
    let matchcomp = [];
    function Loadcompany(setTextval) {
        setShowResults(true);
        const getSectorListUrl = BaseURL + "companysearch/" + setTextval;
        //console.log("getSectorListUrl+" + getSectorListUrl)
        fetch(`${getSectorListUrl}`)
            .then((response) => response.json())
            .then((data) => {
                const myrepo = data.data;
                // console.log(JSON.stringify(myrepo))
                getval = myrepo;
                for (var i = 0; i < getval.length; i++) {
                    // alert("hh")
                    DataFilter.push({
                        CompName: getval[i]['lname'],
                        COCODE: getval[i]['Co_Code'],
                        Exchange: getval[i]['Exchange']
                    });
                }
                //console.log("DataFilter : " + JSON.stringify(DataFilter))
                // setSuggestions(DataFilter);
                matchcomp = DataFilter;
                setSuggestions(matchcomp);
                //console.log("suggestions : " + JSON.stringify(suggestions))
                // console.log("getval : "+JSON.stringify(getval))
                // setcompanysearch(myrepo);
                // console.log(JSON.stringify(companysearch))
                // getcompanydata();
                //console.log(getData);
            })
            .catch((error) => {
                //  console.log(error);
            });
    }
    const onSuggestHandler = event => { setSuggestions([]) }
    const getselectedcompany = (event, param) => { }
    const onChangeHandler = event => {
        let matches = [];
        setText(event.target.value);
        var nameComp = event.target.value;
        if (nameComp.length > 1) {
            Loadcompany(setTextval);
        }
        else {
            setShowResults(false);
            DataFilter = [];
            setSuggestions(DataFilter);
        }
    };
    const companyClick = (paramcode, paramname, paramexchange) => {
        setShowResults(false);
        //setcocode(paramcode);
        //setcompserachcocode(paramcode);
        // navigate("/CompanySnapshot/" + 'nse' + "/" + paramcode + "/" + paramname, {
        //navigate("/stocks/" + paramname.replace(/ /g, '-').replace('&', 'and').replace('+', ''), {
        //});
        document.getElementById('compTextEq').value = paramname;
        window.location.href = "/stocks/" + paramname.replace(/ /g, '-').replace('&', 'and').replace('+', '').replace(/\./g,'').toLowerCase();
        // let path = "/stocks/" + paramname.replace(/ /g, '-').replace('&', 'and').replace('+', '');
        // clickToggleLoginPopup(true,path)
    }

    return (
        <>
            <div className="bgcolor">

                <section className="explore-equities">
                    <Container>
                        <Row>
                            <Col md={{ span: 6, offset: 3 }}>
                                <h3>
                                    <span>Explore Equities</span>
                                </h3>
                                <h5>Search stocks, indices</h5>
                                <input id="compTextEq" type="text" placeholder="Type to search"
                                    onChange={onChangeHandler}

                                />
                                {/* <input type="text" placeholder="Type to search"
                                    
                                
                                /> */}
                                {showResults ?
                                    <div className="suggestion1">
                                        {suggestions && suggestions.map((suggestion, i) =>
                                            <div className="suggestion col-md-12 justify-content-md-center padd-content" onClick={() => companyClick(suggestion.COCODE, suggestion.CompName, suggestion.Exchange)}>{suggestion.CompName}</div>
                                        )}
                                    </div> : ''}

                                {/* {suggestions && suggestions.map((suggestion, i) =>
                <div className="suggestion col-md-12 justify-content-md-center" onClick={() => onSuggestHandler(suggestion.CompName)}>{suggestion.CompName}</div>
              )} */}
                                {/* // <div key={i} className="suggestion" onClick={() => onSuggestHandler(suggestion.CompName)}>{suggestion.CompName}</div> */}
                                {/* <input
                type="text"
                id="message"
                name="message"
                onChange={onChangeHandler}
                value={message}
              /> */}

                                {/* {suggestions && suggestions.map((suggestion, i) =>
                <div className="suggestion col-md-12 justify-content-md-center" >{suggestion.email}</div>
              )} */}
                                {/* 
                            <a href="/AllEquities">
                                <span>Explore all Equities</span>
                            </a>
                        </Col>
                    </Row>
                </Container> */}

                                <div className="ExploreEquityBtn">
                                    <div className="ExploreEquityBtnDiv Explorehover">
                                        <a href="/AllEquities" className="linkEquity">
                                            <span>Explore all Equities</span>
                                        </a>
                                        {/* <a  className="linkEquity">
                                        <span>Explore all Equities</span>
                                    </a> */}
                                    </div>
                                </div>
                            </Col>
                        </Row>
                        {/* <LoginPopup show={show} ref={childRef} /> */}
                    </Container>

                </section>
            </div>
        </>
    );
}
export default ExploreEquities;
